var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('locator-page-map-container',{attrs:{"store-coordinates":_vm.storeCoordinates,"store-details":_vm.storeDetails,"map-classes":"mapbox_b2c_canvas","mapbox-api-key":_vm.mapboxApiKey,"qaid":"locator-page-map-container"}})}
var staticRenderFns = []

export { render, staticRenderFns }